import { jsx as t } from "react/jsx-runtime";
import { lazy as o } from "react";
import { useCurrentStage as m } from "@perxis-auto/trade-in-sdk";
import { APP_ROUTES as i } from "../../../shared/config/routing.js";
import { Loader as n } from "../../../shared/ui/Loader/Loader.js";
const p = o(() => import("../../../pages/ErrorStage/index.js")), u = o(() => import("../../../pages/SuccessStage/index.js")), a = o(() => import("../../../pages/Stage/index.js"));
function C() {
  const { current: r, data: e } = m();
  return r ? r === i.SUCCESS ? /* @__PURE__ */ t(u, {}) : r && e ? /* @__PURE__ */ t(a, {}, r) : /* @__PURE__ */ t(p, {}) : /* @__PURE__ */ t(n, {});
}
export {
  C as AppRouter
};
